import React, { Component } from 'react';
import moment from 'moment';
import LoadingIcon from '../shared/LoadingIcon';
import Link from '../shared/Link';
import i18n from '../../config/i18n';

class RecordList extends Component {
  render() {
    const { isLoading, recordData, router } = this.props;
    let currentView;

    if (isLoading) {
      currentView = (
        <tr style={{ textAlign: 'center' }}>
          <td />
          <td><LoadingIcon /></td>
          <td />
        </tr>
      );
    } else if (recordData.length === 0) {
      currentView = (
        <tr style={{ textAlign: 'center' }}>
          <td />
          <td>
            {i18n.t('noRecordMsg')}
          </td>
          <td />
        </tr>
      );
    } else {
      currentView = recordData.map((patient, index) => (
        <tr key={patient.id}>
          <td>
            <Link href={`records/${patient.id}`} router={router}>
              {index + 1}
            </Link>
          </td>
          <td>{`${patient.doctor.user.firstName} ${patient.doctor.user.lastName}`}</td>
          <td>{moment(patient.lastUpdated).format('YYYY-MM-DD')}</td>
        </tr>
      ));
    }
    return (
      <table
        className="table table-striped table-hover table-responsive patient-list"
        style={{ width: '100%' }}
      >
        <thead style={{ backgroundColor: '#607484', color: '#FFF' }}>
          <tr>
            <th>#</th>
            <th>{i18n.t('doctorName')}</th>
            <th>{i18n.t('lastVisit')}</th>
          </tr>
        </thead>
        <tbody>
          {currentView}
        </tbody>
      </table>
    );
  }
}

export default RecordList;



// WEBPACK FOOTER //
// ./src/components/record/RecordList.js